<template>
    <div class="tab-content-box">
        <el-alert title="白名单演出项目发送营销短信不计费" type="warning" :closable="false"></el-alert>
        <el-form :model="formData" ref="formData" label-position="top" class="MT10">
            <el-form-item prop="userIds" label="演出ID:">
                <el-input
                    v-model="formData.userIds"
                    type="textarea"
                    placeholder="请输入演出ID"
                    :rows="4"
                ></el-input>
                <small class="from-tip"><span class="el-icon-warning"></span> ID间请使用英文逗号隔开</small>
            </el-form-item>
			<table v-if="idNameList && idNameList.length > 0" class="info-table">
				<tbody>
					<tr v-for="(row, rowIndex) in rows" :key="rowIndex">
						<td v-for="item in row" :key="item.id">
							<div>演出ID: {{ item.id }}</div>
							<div>演出名称: {{ item.name }}</div>
						</td>
						<td v-for="n in (3 - row.length)" :key="'empty-'+n"></td>
					</tr>
				</tbody>
			</table>
            <el-form-item>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { detailAction, editAction, addAction } from "../api";

export default {
	props: {
		// 接收父组件传递的激活状态
		isActive: {
			type: Boolean,
			default: false
		}
	},
    data() {
        return {
            formData: {
                id: "",
                type: 13,
                userIds: "",
            },
            btnLoading: false,
            idNameList: [],
            hasLoaded: false
        };
    },
    watch: {
    	// 监听 isActive 变化
    	isActive: {
    		handler(val) {
    			if (val && !this.hasLoaded) {
    				this.getDataDetail();
    			}
    		},
    		immediate: true
    	}
    },
    computed: {
    	rows() {
    		const rows = [];
    		for (let i = 0; i < this.idNameList.length; i += 3) {
    			rows.push(this.idNameList.slice(i, i + 3));
    		}
    		return rows;
    	}
    },
    methods: {
        async getDataDetail() {
            const res = await detailAction({
                type: this.formData.type,
            });
            const { state, msg, result } = res.data;
            if (state == 1) {
				let originalList = result.idNameList ? result.idNameList : [];
				const map = new Map();
				this.idNameList = originalList.filter(item => {
					if (!map.has(item.id)) {
						map.set(item.id, true);
						return true;
					}
					return false;
				});				
                this.formData = { ...this.formData, ...result };
            } else {
                this.$message.error(msg || "请求失败");
            }
        },

        async onSubmit() {
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    let _res = '';
                    if( this.formData.id ){
                        _res = await editAction(this.formData);
                    }else{
                        _res = await addAction(this.formData);
                    }

                    const { state, msg } = _res.data;
                    this.btnLoading = false;
                    if (state == 1) {
                        this.$message.success("设置成功");
                        this.getDataDetail();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }  
                }
            });
        },
    },
};
</script>
<style>
	.info-table {
		width: 100%;
		margin: 20px 0;
	}

	.info-table td {
		border: 1px solid #ddd;
		padding: 12px;
		vertical-align: top;
		min-width: 150px;
	}

	.info-table td div:first-child {
		font-weight: bold;
		color: #1890ff;
	}

	.info-table td div:last-child {
		margin-top: 5px;
		color: #666;
	}
</style>